var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRokuDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 29,
    viewBox: "0 0 91 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6173 10.1584C14.6173 7.58971 12.5453 5.52104 10.0116 5.52104H7.72756V14.7548H10.0116C12.5453 14.7548 14.6173 12.6848 14.6173 10.1584ZM25.0072 28.5664H16.6229L9.96631 19.3532H7.72756V28.5466H0.33844V0.927431H10.9238C17.0262 0.927431 22.0072 5.06613 22.0072 10.1584C22.0072 13.2642 20.0976 16.0381 17.1915 17.7353L25.0072 28.5664Z",
    fill: "#0E0E0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3405 11.816C31.3891 11.816 29.7293 14.4613 29.7293 17.736C29.7293 21.0107 31.3891 23.6595 33.3405 23.6595C35.3371 23.6595 36.9942 21.0107 36.9942 17.736C36.9942 14.4613 35.3371 11.816 33.3405 11.816ZM44.714 17.736C44.714 23.9919 39.613 29.0015 33.3405 29.0015C27.0701 29.0015 22.0068 23.9919 22.0068 17.736C22.0068 11.4849 27.0701 6.47258 33.3405 6.47258C39.613 6.47258 44.714 11.4849 44.714 17.736Z",
    fill: "#0E0E0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.054 6.93092L53.542 15.419V6.90287H46.1543V28.5465H53.542V19.767L62.4285 28.5465H71.7271L60.4346 17.2825L69.7881 7.95704V20.8014C69.7881 25.0659 72.3595 29.0015 78.835 29.0015C81.9092 29.0015 84.7303 27.2625 86.1013 25.6891L89.4231 28.5465H91V6.93092H83.6122V18.1923V20.9259C82.7803 22.3741 81.6211 23.2846 79.8296 23.2846C78.0119 23.2846 77.1779 22.2099 77.1779 18.7724V17.8653V6.93092H62.054Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRokuDark);
export default __webpack_public_path__ + "static/media/roku-dark.0bf8fd22bc36873724c428e7438ce3aa.svg";
export { ForwardRef as ReactComponent };